export const speakers = [
    {
        "id": "RXZlbnRQZW9wbGVfMjc1MTIxMDk=",
        "type": "Speaker",
        "firstName": "Jonathan",
        "lastName": "Worsley",
        "jobTitle": "Chairman",
        "organization": "The Bench",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDI2MDMwMw==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc1MTIxOTc=",
        "type": "Speaker",
        "firstName": "Thomas",
        "lastName": "Emanuel",
        "jobTitle": "Senior Director",
        "organization": "STR, a CoStar Group Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/76bfadbf7c9a46fc9a020b039d7d3855.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV85MjAzNTE2",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM1NjE=",
        "type": "Speaker",
        "firstName": "Sultan",
        "lastName": "Bader Al-Otaibi",
        "jobTitle": "Chief Executive Officer",
        "organization": "Taiba Investments",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/9410ea2905734ed69b3e14688d5f0f9f.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNzI2OA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM1NzU=",
        "type": "Speaker",
        "firstName": "Giuliano",
        "lastName": "Gasparini",
        "jobTitle": "Head of Hospitality Asset Management",
        "organization": "WASL / Dubai Real Estate Corporation",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1185b82f30fb4c59b01dd92aafdcf851.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYxNjQwNQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM2MTI=",
        "type": "Speaker",
        "firstName": "Amit",
        "lastName": "Nayak, CHA",
        "jobTitle": "Vice President",
        "organization": "HAMA MEA",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d4b4f2d6da9e4da5a6ef922931e3eb58.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNzY0Mg==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM2Mzk=",
        "type": "Speaker",
        "firstName": "Shaikha",
        "lastName": "Al Nowais",
        "jobTitle": "Corporate Vice President - Owner Relationship Management",
        "organization": "Rotana",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/021971f022ac456db0218fde09ed3808.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDY4NA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM2NDY=",
        "type": "Speaker",
        "firstName": "JS",
        "lastName": "Anand",
        "jobTitle": "Founder & CEO",
        "organization": "Leva Hotels",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/0f77c61aeb96470ba1a89680e273a473.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY4MDI5MA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM2NTc=",
        "type": "Delegate",
        "firstName": "Hala Matar",
        "lastName": "Choufany",
        "jobTitle": "President, Europe, Middle East & Africa (EMEA)",
        "organization": "HVS",
        "photoUrl": "https://static.swapcard.com/public/images/549da4fcfc694dcb8df2683d18e07225.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjkyOA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM2NjU=",
        "type": "Speaker",
        "firstName": "Marco",
        "lastName": "Franck",
        "jobTitle": "Chief Hospitality Officer",
        "organization": "Boutique Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4894663f2cf44e4fa0ac0c83fd743db6.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTczMjMyOQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM2ODE=",
        "type": "Speaker",
        "firstName": "Makram El",
        "lastName": "Zyr",
        "jobTitle": "Corporate Vice President – Development",
        "organization": "Rotana",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/abcf1b5ac2424d29a2628c6a119757d3.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjU0Njc2OA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM2OTg=",
        "type": "Speaker",
        "firstName": "Aradhana",
        "lastName": "Khowala",
        "jobTitle": "CEO & Founder",
        "organization": "Aptamind Partners",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1db9674ed24c4de5807e41f7e15ac1f1.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM2NQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM3MDU=",
        "type": "Speaker",
        "firstName": "Susie",
        "lastName": "Ellis",
        "jobTitle": "Chair & CEO",
        "organization": "Global Wellness Institute and Global Wellness Summit",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d88f3e7867af4f4ab9faffc5fefc8841.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYxNjQ5OA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM3Mzk=",
        "type": "Speaker",
        "firstName": "Abdullah",
        "lastName": "Azhari",
        "jobTitle": "Chief Executive Officer",
        "organization": "Saudi Icon Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4fdf53d37b004fe1a6d8cdf05e9fdd85.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYxNjUyNw==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM4MTA=",
        "type": "Moderator",
        "firstName": "Scott",
        "lastName": "Antel",
        "jobTitle": "Founder & Owner",
        "organization": "Scotts FZ LLE",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/750373591fb945a3b6ee3e909a226df6.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Lawyer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQ1Ng==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM4MjU=",
        "type": "Speaker",
        "firstName": "Louis",
        "lastName": "Abboud",
        "jobTitle": "Chief Development Officer & Deputy Head of Middle East, Africa & Turkey",
        "organization": "Global Head, F&B Development, Ennismore",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/fc5fda656ea943b2ac6c1d865715584a.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQwOQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM4Mzk=",
        "type": "Speaker",
        "firstName": "Christoph",
        "lastName": "Hoffmann",
        "jobTitle": "Founder",
        "organization": "25hours Hotels",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/3d075c630818485aa84b95f95ea4bca2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYxNjYwMg==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM4NTg=",
        "type": "Moderator",
        "firstName": "Nicolas",
        "lastName": "Nasra",
        "jobTitle": "Head of Hotel Advisory, Hospitality & Tourism | MENA Region",
        "organization": "Colliers",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjI0OTIzNw==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM4NzM=",
        "type": "Speaker",
        "firstName": "Henri Giscard",
        "lastName": "D’Estaing",
        "jobTitle": "President",
        "organization": "ClubMed - All-Inclusive beach and mountain Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ad0eca8e39054a7395545f8350674029.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYxNjYyNQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM4OTc=",
        "type": "Speaker",
        "firstName": "Mark",
        "lastName": "De Cocinis",
        "jobTitle": "Chief Executive Officer",
        "organization": "Boutique Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/a5d5d41c8a6044fbb44c53d5660991e0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQwOA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5NzM5NTg=",
        "type": "Speaker",
        "firstName": "Khalid Saud",
        "lastName": "Abu Haimed",
        "jobTitle": "Chief Executive Officer",
        "organization": "Al Khozama Investment Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/047feab9eb2745eb9cc8cbfdd1cd09e2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYxNjY4MQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5ODEzMTY=",
        "type": "Speaker",
        "firstName": "Luis Nicolás",
        "lastName": "Barrios",
        "jobTitle": "Regional Manager - Innovation, Education and Investments",
        "organization": "UN Tourism",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/3e48bf508a3f4f5a855d9b179a19b4ec.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYyMjE0NQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjc5ODE0MzU=",
        "type": "Judge",
        "firstName": "Salma",
        "lastName": "Arafa",
        "jobTitle": "Senior Innovation Specialist",
        "organization": "UN Tourism",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d9a29fb8b19a4f12a74b916091d7393f.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Judge",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYyMjIxNg==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgwMDM1NTQ=",
        "type": "Speaker",
        "firstName": "Fahad Abdulrahim",
        "lastName": "Kazim",
        "jobTitle": "Chief Executive Officer",
        "organization": "Millennium Hotels & Resorts & Lakhraim Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/cce6b9371ceb464091d2b84d9911355f.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDYzODk4Mw==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgwMzUyMTg=",
        "type": "Speaker",
        "firstName": "Turab",
        "lastName": "Saleem",
        "jobTitle": "Partner - Head of Hospitality, Tourism & Leisure - MENA",
        "organization": "Knight Frank",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e8f6578826434c8cbc89db951fa9a9e2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQ0Nw==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgwNDY0OTA=",
        "type": "Moderator",
        "firstName": "Fritz",
        "lastName": "Dickamp",
        "jobTitle": "Managing Director",
        "organization": "Studio 49",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2036c6d15c0647e4ad00d055e433e9be.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQzMw==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgwNjcwMTA=",
        "type": "Speaker",
        "firstName": "Dr. Fahad",
        "lastName": "Bin Mushayt",
        "jobTitle": "Chief Executive Officer",
        "organization": "ASFAR",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/f777a708539f421bb26d3e7dfcc7daad.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjE1MTQ3Ng==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgxMzM4MzQ=",
        "type": "Speaker",
        "firstName": "Suma",
        "lastName": "Venkatesh",
        "jobTitle": "Executive Vice President – Real Estate & Development",
        "organization": "The Indian Hotels Company Limited",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ab0f7a5ca0ac4be2a3e2f1d4b1154738.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM5NQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgxMzM4NjM=",
        "type": "Speaker",
        "firstName": "Paul",
        "lastName": "Bridger",
        "jobTitle": "Chief Operating Officer",
        "organization": "Rove Hotels",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c3ee50cc462e49ac86d1a8a097a15de2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQxOQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgxMzM4Nzc=",
        "type": "Moderator",
        "firstName": "Mike",
        "lastName": "Rigby",
        "jobTitle": "GM & RVP, Middle East",
        "organization": "WhiteWater",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2af47e6359fa4c72a6763f40226541b9.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Supplier",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDczNzI0MQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgxNDcyNDM=",
        "type": "Speaker",
        "firstName": "Panos",
        "lastName": "Loupasis",
        "jobTitle": "Market Managing Director Türkiye, Middle East & Africa",
        "organization": "Wyndham Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/cfcc35a1b06f4109ad5cecfc02afba5a.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Delegate",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjkyNQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgxNDg0Mzg=",
        "type": "Moderator",
        "firstName": "Edie",
        "lastName": "Rodriguez",
        "jobTitle": "Member of the Board of Directors",
        "organization": "Saudi Tourism Authority",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/f6b3f788b42a407dab1e342850d9aba0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDc0NzkyOQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgyNTA3NTI=",
        "type": "Speaker",
        "firstName": "Hassan",
        "lastName": "Ahdab",
        "jobTitle": "Chief Hospitality Operations Officer",
        "organization": "Taiba Investments",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/29735f117d6442c9a838312bceeeee9e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjg5NQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgyODM0NjQ=",
        "type": "Speaker",
        "firstName": "Elie",
        "lastName": "Milky",
        "jobTitle": "Vice President Development ME, Cyprus, Greece & Pakistan",
        "organization": "Radisson Hotel Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/3e57faf6b16b416ba6dece262ac74733.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNzAzMw==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzNzA3NzU=",
        "type": "Speaker",
        "firstName": "Patrick",
        "lastName": "Smith",
        "jobTitle": "Chief Operating Officer",
        "organization": "Strive Services Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/54f79764c96e4a9eb94fc822fb7bad32.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY4MDYzMQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzNzEwNTA=",
        "type": "Speaker",
        "firstName": "Markus",
        "lastName": "Schreyer",
        "jobTitle": "Chairman",
        "organization": "META Foundation",
        "photoUrl": "https://static.swapcard.com/public/images/37bd745766e64fc69bfef0b26ba9e3a0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkxOTAxMg==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzNzI3MDU=",
        "type": "Speaker",
        "firstName": "Waleed",
        "lastName": "M. Abualnadi",
        "jobTitle": "Commercial Director",
        "organization": "Saudi Icon Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/88c841025ae541499e96edae25303cdc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Construction",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkyMDMwOQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTI4ODQ=",
        "type": "Speaker",
        "firstName": "Hashim",
        "lastName": "Al-Attas",
        "jobTitle": "Chief Executive Officer, Leylaty Group",
        "organization": "Co-Founder, Kuruu",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/7c75c040ca144de78392b6649672a00c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjA3NA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTI5ODk=",
        "type": "Speaker",
        "firstName": "Abdulaziz",
        "lastName": "Alkhudair​",
        "jobTitle": "Managing Director, Majd Alaamal",
        "organization": "CEO, Yakoon Invest Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/a04630d7afb34d8d94086a1dc9c7c14f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDc=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjE2NA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTMwNTc=",
        "type": null,
        "firstName": "Sinan",
        "lastName": "Al Saady",
        "jobTitle": "Group Chief Executive Officer",
        "organization": "Cool Inc",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjIwMg==",
                    "createdAt": "2024-04-27 20:16:07"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTMxMTY=",
        "type": "Speaker",
        "firstName": "Benjamin",
        "lastName": "Calleja",
        "jobTitle": "Founder",
        "organization": "Livit Design & Fast Fine Restaurant Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ba53bbda2cd7412fbe327a2ad428c24f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjkwOA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTMxNDc=",
        "type": "Speaker",
        "firstName": "Gustavo De",
        "lastName": "Hostos",
        "jobTitle": "Founder & Managing Partner",
        "organization": "Forsite Creative",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/7f3d496d1fa84a62b29c020bff30bed5.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM4NA==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTMyNzc=",
        "type": "Speaker",
        "firstName": "Michael",
        "lastName": "Flanagan",
        "jobTitle": "Chief Business Development Officer",
        "organization": "Al Khozama Investment Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d2a99d425306444c9f11e30155a7913b.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjM2MA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTMzNTY=",
        "type": "Speaker",
        "firstName": "Mohammed",
        "lastName": "Jawa",
        "jobTitle": "Founder & Chairman",
        "organization": "MJS Holding",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4624c1bfeab94dbab4187b9803955adc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjQzMA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTMzOTY=",
        "type": "Speaker",
        "firstName": "Rizwan",
        "lastName": "Kassim",
        "jobTitle": "Founder & CEO",
        "organization": "RIKAS Hospitality Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bfd98485cb0646bfba84fdb2f7c29cfd.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTkxNjMwNg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTM0Njc=",
        "type": "Speaker",
        "firstName": "Uday",
        "lastName": "Mukundan",
        "jobTitle": "Chief Executive Officer",
        "organization": "The Food District Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d1c8aadd133c4366ad210b0a640882a8.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjUyMw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTM1MDI=",
        "type": "Speaker",
        "firstName": "Roaya",
        "lastName": "Saleh",
        "jobTitle": "Founder, Villa Mamas",
        "organization": "President & Founder, RS Management WLL",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e20fcbf2e38740a59f99836830b72e47.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjMwNzYyMA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTM2MDM=",
        "type": "Speaker",
        "firstName": "Faisal",
        "lastName": "Shaker",
        "jobTitle": "Co Founder, Board Member & CEO",
        "organization": "Modern Food Company (MFC) & Modern Elite Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e61dee443ec744c4bc55ef239305b56a.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjYzMA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTM3MTc=",
        "type": "Speaker",
        "firstName": "Henrik",
        "lastName": "Winther",
        "jobTitle": "Founder",
        "organization": "Tigrus Holding",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/059744487ea44606b520869783c26a9e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjY2OQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTM4MTY=",
        "type": "Speaker",
        "firstName": "Ada",
        "lastName": "Renedo",
        "jobTitle": "Regional CEO, Middle East",
        "organization": "Together Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/453b9480592b410ca87fcc883ad8c863.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjY5Ng==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjgzOTQxMzM=",
        "type": "Speaker",
        "firstName": "Christopher",
        "lastName": "Sanderson",
        "jobTitle": "Co-Founder",
        "organization": "The Future Laboratory",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/93258c18465e4da1a567359699c2b016.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDkzNjkyMA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg0ODEyNzg=",
        "type": "Speaker",
        "firstName": "Martin",
        "lastName": "Raymond",
        "jobTitle": "Co-Founder, The Future Laboratory",
        "organization": "Editor-in-Chief, LS:N Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4752c911000848768031f357a2332047.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNDk5OTI5Ng==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg0ODgyMjE=",
        "type": "Speaker",
        "firstName": "Jennifer",
        "lastName": "Pettinger-Haines",
        "jobTitle": "Co-Founder, Global Restaurant Investment Forum",
        "organization": "Partner, THINK Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/f309f54478254e93bbb14b9f13313b8a.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTAwNDYxMw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg1MTc4NjM=",
        "type": "Speaker",
        "firstName": "Janet",
        "lastName": "Adams",
        "jobTitle": "Chief Operating Officer",
        "organization": "SingularityNET",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/a484544b78874b6592977392d766bedd.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTAyNjMwOA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg1NDkyMDM=",
        "type": "Speaker",
        "firstName": "Glenn",
        "lastName": "Mandziuk",
        "jobTitle": "Chief Executive Officer",
        "organization": "Sustainable Hospitality Alliance",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/431472c4cc334203850dac4f47ff261d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQzMA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg1NTkzMjc=",
        "type": "Speaker",
        "firstName": "Haitham",
        "lastName": "Mattar",
        "jobTitle": "Special Advisor, UNWTO",
        "organization": "Managing Director MEA & South West Asia, IHG Hotels & Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/16139fb181bf4c52924f2e5e73a3ec80.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjA2Nzg4Nw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg2MTgyMzE=",
        "type": "Speaker",
        "firstName": "Shaji",
        "lastName": "Abu Salih",
        "jobTitle": "Vice President - Business Development & Growth",
        "organization": "Shaza Hotels",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/8714f4577ed749f5ad80b658e0190a19.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTc4NzUwOA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg2NTM0MTY=",
        "type": "Speaker",
        "firstName": "Sebastien",
        "lastName": "Carre",
        "jobTitle": "Group Head of Hospitality",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/5d687c7d1bd34fe383f0c0a3ba7da1c4.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTExMzQ0Nw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3MDM0MjI=",
        "type": "Speaker",
        "firstName": "Marloes",
        "lastName": "Knippenberg",
        "jobTitle": "Chief Executive Officer",
        "organization": "Kerten Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/aadc31d5ddd34fcabc0aca59a0182e30.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTE0ODAzMA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3MDM0Mzc=",
        "type": "Speaker",
        "firstName": "Henry",
        "lastName": "Coutinho-Mason",
        "jobTitle": "Author & Speaker, The Future Normal",
        "organization": "Co-founder, 3Space",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/fc6293ced5834145b38756ca93676917.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjM3ODY3Ng==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3MDM0NDY=",
        "type": "Speaker",
        "firstName": "Ali",
        "lastName": "Shahid",
        "jobTitle": "Marketing Director, The Bench",
        "organization": "Generative AI Evangelist",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bd0dbdf1442141679c3df8de64b62560.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTE2OTU2Mg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3MDM3MTA=",
        "type": "Speaker",
        "firstName": "Kathrin",
        "lastName": "Cockhill",
        "jobTitle": "Commercial Director",
        "organization": "HotStats",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b97fda9665d44367ae630f362aa1b961.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTE0ODIzNA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3MDQ3NTE=",
        "type": "Speaker",
        "firstName": "Gregory",
        "lastName": "Lanter",
        "jobTitle": "CEO Global Development Construction Property",
        "organization": "ClubMed - All-Inclusive beach and mountain Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bd21592bd99c45d3afe4fb5b2ccc5f1c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjM1MzMzOQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3MzA1OTY=",
        "type": "Speaker",
        "firstName": "Nicholas",
        "lastName": "Clark",
        "jobTitle": "Program Director",
        "organization": "Compass Project Consulting",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/6fc76d7772bc4405b415dd5d61e87837.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTE2NjY5Mw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3MzA5NzQ=",
        "type": "Speaker",
        "firstName": "Aseel",
        "lastName": "Bondagjy",
        "jobTitle": "Hotel Talent Development Manager",
        "organization": "NEOM",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/3fffa064c5cd4e428752d3e1d7a8a0b9.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTg3NzM4Mg==",
                    "createdAt": "2024-04-26 10:35:02"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3MzA5OTI=",
        "type": "Speaker",
        "firstName": "Tatiana",
        "lastName": "Labaki",
        "jobTitle": "Head of Hotels and Tourism Advisory - PSU",
        "organization": "Tonomus",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1e221c27233146fb93298f3f88259b27.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTg3NTgzMw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3NzQxNzM=",
        "type": "Speaker",
        "firstName": "Abdulrahman",
        "lastName": "AlMalik",
        "jobTitle": "Investment Development Executive Director",
        "organization": "ASFAR",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/eb9aacd610b74d77a0e70f38c84d48e8.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTE5OTM3NQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3NzQ3MTM=",
        "type": "Speaker",
        "firstName": "Serena",
        "lastName": "Lim",
        "jobTitle": "Chief Growth Officer",
        "organization": "The Ascott Limited",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/001a18f724f34456972674b28bbe07a1.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NTM5NA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg3NzQ3MzI=",
        "type": "Speaker",
        "firstName": "Siew Kim",
        "lastName": "Beh",
        "jobTitle": "Chief Financial & Sustainability Officer, Lodging",
        "organization": "CapitaLand Investment Limited / The Ascott Limited",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1e8dcfc0631a453eb56f07e2d300faab.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTE5OTgzOA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg5MTk5ODA=",
        "type": "Speaker",
        "firstName": "Ahmed",
        "lastName": "Bin Madhi",
        "jobTitle": "Chief Investment Officer",
        "organization": "Rua Al Madinah Holding Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/6b4df4542aeb487e81145e64beb7e9e6.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTI5NjM4OA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg5MjAxOTk=",
        "type": "Speaker",
        "firstName": "Mario",
        "lastName": "Ferraro",
        "jobTitle": "CEO",
        "organization": "Smeralda Holding Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bb2001f6d5404512b72f94d8fbe24cb9.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTI5NjU1OQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg5MjA0NjY=",
        "type": "Speaker",
        "firstName": "Ahmed",
        "lastName": "Zeeshan",
        "jobTitle": "Technical Consultant",
        "organization": "HPE Aruba Consulting Systems Engineer",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b531f69fb5084260a620c26478431e19.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Supplier",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTI5Njc4NA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg5MjA1ODM=",
        "type": "Speaker",
        "firstName": "Adil",
        "lastName": "Jabrayilov",
        "jobTitle": "Development Director MENA",
        "organization": "Louvre Hotels Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e8db8e58573c4e0ba752101aa67f06b4.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTI5Njg3NQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg5MjUwNTA=",
        "type": "Moderator",
        "firstName": "Richard",
        "lastName": "Williamson",
        "jobTitle": "COO",
        "organization": "The Considerate Group",
        "photoUrl": "https://static.swapcard.com/public/images/4bbae35ad27d473a9510a393ab25dfd0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTMwMDI0MA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg5MjY5MTU=",
        "type": "Moderator",
        "firstName": "Ali",
        "lastName": "Manzoor",
        "jobTitle": "Head of Hotels & Tourism",
        "organization": "CBRE MENA",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ee75f5da2004484ebe7a16782b1cd54b.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQ1Mg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjg5Mjc3OTU=",
        "type": "Speaker",
        "firstName": "Tariq",
        "lastName": "Yousef Dowidar",
        "jobTitle": "Vice President Saudi Arabia",
        "organization": "Aleph Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/45881074548642c7881bc4ae6e0a4784.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDY5Ng==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkwNDg3ODM=",
        "type": "Speaker",
        "firstName": "Khalid",
        "lastName": "Al Gahtani",
        "jobTitle": "Chairman",
        "organization": "Rikaz Properties",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/fc8bb1e1ec5542fda005a5a730bc7cdf.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTM5Njg3Mw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkwNTEwMTI=",
        "type": "Speaker",
        "firstName": "Khalid",
        "lastName": "Al-Amoudi",
        "jobTitle": "Chief Executive Officer",
        "organization": "Jabal Omar Development Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/45cc221faaec46ebbc2dc1a350278825.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTM5ODYzOA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkwNTEzMjQ=",
        "type": "Speaker",
        "firstName": "Falih",
        "lastName": "Motasim Hajaj",
        "jobTitle": "Chief Executive Officer",
        "organization": "Tashyid Urban Development",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/abbeb0c0ebaa4f17b7ad85e5e6c8fb4c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTM5ODg3MQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkwNTE3MDU=",
        "type": "Speaker",
        "firstName": "Bilal",
        "lastName": "Ambikapathy",
        "jobTitle": "Partner",
        "organization": "Wisefields",
        "photoUrl": "https://static.swapcard.com/public/images/5f4b835a223541c384c9fb2bf087024f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Lawyer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTM5OTE1OQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkwNTUxNzI=",
        "type": "Speaker",
        "firstName": "Stefano",
        "lastName": "Lopez",
        "jobTitle": "Tourism Projects Director",
        "organization": "Baheej",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c2b7dd92cad5410880c48278c22d9e07.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjM1MzM0MA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkwNjM2NjU=",
        "type": "Speaker",
        "firstName": "Abdulrahman",
        "lastName": "Albassam",
        "jobTitle": "Board Member",
        "organization": "Baheej",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d6028e7cbc5c40a397604d38790ad73b.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjQ3MjUyMg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkwNjQ4ODU=",
        "type": "Speaker",
        "firstName": "Julien",
        "lastName": "Laloye",
        "jobTitle": "Director, Mixed-Use Development (EMEA)",
        "organization": "Marriott International",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/87c9b931df3243d1a7ea88d1c7554587.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NTQwMA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkxMTExOTE=",
        "type": "Speaker",
        "firstName": "Osama",
        "lastName": "AlOthman",
        "jobTitle": "Chief Executive Officer",
        "organization": "Aseer Investment Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/854dcb2185df42228823e8a00677a8bb.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTQ0Mzc0OQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkzMDc2MTU=",
        "type": "Speaker",
        "firstName": "Hitesh",
        "lastName": "Gandhi",
        "jobTitle": "Senior Director Development – KSA and Kuwait",
        "organization": "Marriott International",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c973b4119d9647b4b6d471b683fb3e8a.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDcyMA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkzMDc3MzM=",
        "type": "Moderator",
        "firstName": "Mohammed",
        "lastName": "Islam",
        "jobTitle": "Host & Founder",
        "organization": "The Mo Show Podcast Saudi Arabia",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2a41038717d84318b27a383e0a8a13fb.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTU5OTQxNA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjkzNDc2Mzg=",
        "type": "Speaker",
        "firstName": "Tapan",
        "lastName": "Piplani",
        "jobTitle": "Chief Operating Officer",
        "organization": "Valor Hospitality Partners- Middle East & CIS",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/3c30019bbb0e48dc8cd77233ce9926ff.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM4OQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk0MjkyNjQ=",
        "type": "Speaker",
        "firstName": "Mahmoud",
        "lastName": "Abdulhadi",
        "jobTitle": "Deputy Minister, Destination Enablement",
        "organization": "Ministry Tourism of Saudi Arabia",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/8286f8486b46414b8748371435717d7c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTY5ODA2MQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk0MzA0OTg=",
        "type": "Moderator",
        "firstName": "David",
        "lastName": "Keen",
        "jobTitle": "CEO & Founder",
        "organization": "QUO",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/218657551e024aaab1a1de67504600ab.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTkyMDc4Ng==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk0MzE3NjM=",
        "type": "Moderator",
        "firstName": "Rana",
        "lastName": "Tabbara",
        "jobTitle": "Reporter",
        "organization": "CNN Business Arabic",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/89acb46a77f245b9a24dab0275fc3d39.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjU0NDk4Mg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk0MzYxNjc=",
        "type": "Speaker",
        "firstName": "Desdemona",
        "lastName": "(Desi)",
        "jobTitle": "Humanoid Robot",
        "organization": "Lead Vocalist of the Desdemona Dream Band",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e5aedb9990a24dc78adc0d6502f61239.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTcwMzYzNQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk0NjExNTQ=",
        "type": "Moderator",
        "firstName": "Simon",
        "lastName": "Wright",
        "jobTitle": "Founder & Chairman",
        "organization": "TGP International",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1e28c84ddb2a418095833b23a57d14fc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTcyMzYwMw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk0OTM4OTc=",
        "type": "Speaker",
        "firstName": "Ashish",
        "lastName": "Tulsian",
        "jobTitle": "Co-founder & CEO",
        "organization": "Restroworks",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ad7d6efcf1f043398a8ad3eb04cb61b4.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM3MQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk1NTMyNjM=",
        "type": "Speaker",
        "firstName": "Ingo",
        "lastName": "Schweder",
        "jobTitle": "Founder & CEO",
        "organization": "GOCO Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/dce9579bcb0743bc96d8977133aadc67.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQwNg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk1NTMyNzQ=",
        "type": "Speaker",
        "firstName": "Fawaz",
        "lastName": "Moumina",
        "jobTitle": "Country Manager & Senior Director of Operations – Saudi Arabia",
        "organization": "Hilton",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4ad52134afbb4b38a26cba8db099b2a0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTc5MzUwNg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk1NTM0OTM=",
        "type": "Speaker",
        "firstName": "Joe",
        "lastName": "Tabet",
        "jobTitle": "Managing Director",
        "organization": "JT+Partners",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/92f3ad3bab5d49eebb2b626ffb308ba2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTc5MzcwNQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk1NTM3OTM=",
        "type": "Speaker",
        "firstName": "Coley",
        "lastName": "Brenan",
        "jobTitle": "Partner, Head of Europe",
        "organization": "KSL Capital Partners",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/912f9161493048bfb746abf77baac9cd.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNzg3NA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk1NTkxMTE=",
        "type": "Speaker",
        "firstName": "Maher",
        "lastName": "Abou Nasr",
        "jobTitle": "Vice President Operations Saudi Arabia",
        "organization": "IHG Hotels & Resorts",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1e69da694e74461e96c99804a27218ec.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTc5NzI2OQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk2MDU2MjQ=",
        "type": "Speaker",
        "firstName": "Dr. Adel",
        "lastName": "Ezzat",
        "jobTitle": "Chief Executive Officer",
        "organization": "Elaf Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/7281fa04e79d44e0b7a2f6d4c7dec072.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM4OA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk2NzQzMzY=",
        "type": "Moderator",
        "firstName": "Hiba",
        "lastName": "Araji",
        "jobTitle": "Regional Design & Project Development Manager - Middle East & CIS",
        "organization": "Valor Hospitality Partners",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/32247bdf71694f879f984b782f1340c8.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTg3ODczNA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk2Nzk1NTE=",
        "type": "Speaker",
        "firstName": "Oliver",
        "lastName": "Bonke",
        "jobTitle": "Chief Executive Officer, H World International",
        "organization": "Managing Director, Steigenberger Hotels GmbH",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/60d4162adf374db99b90e5aa99e0135f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTg4MzcwNA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3MjA4MDk=",
        "type": "Speaker",
        "firstName": "Rosanna",
        "lastName": "Chopra",
        "jobTitle": "Executive Director – Destination Development",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d47e4702151142bbbe05cf736f42600d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTkxNDQ5NQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3MjE2NTE=",
        "type": "Speaker",
        "firstName": "Lars",
        "lastName": "Eltvik",
        "jobTitle": "Senior Advisor – Education",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c7cd0ad93c27488096897d77b7e47745.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTkxNTEzMg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NDEyMjg=",
        "type": "Speaker",
        "firstName": "Marcello",
        "lastName": "Distefano",
        "jobTitle": "Chief Executive Officer",
        "organization": "San Carlo Restaurant Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/41a626f4614048c68ab96bf1e6a99b4b.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTkzMDY5NQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NDE0MTU=",
        "type": null,
        "firstName": "Oliver",
        "lastName": "Wood",
        "jobTitle": "Senior Director - Destination Development",
        "organization": "Red Sea Global",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTkzMDgzNA==",
                    "createdAt": "2024-04-28 22:18:53"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NDE0MjE=",
        "type": "Speaker",
        "firstName": "Oliver",
        "lastName": "Wood",
        "jobTitle": "Senior Director – Adventure & Sport",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/46e6b54ecf5f4920977ca060dc238339.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTkzMDgzOQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NDE0NzI=",
        "type": "Speaker",
        "firstName": "Ben",
        "lastName": "Edwards",
        "jobTitle": "Group Head of Cost, Commercial, and Procurement",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ad11f8c77ccf4d0dbd9386316aa311ca.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTkzMDg4MQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NDE4MDY=",
        "type": "Speaker",
        "firstName": "Guy",
        "lastName": "Hutchinson",
        "jobTitle": "President, Middle East & Africa (MEA)",
        "organization": "Hilton",
        "photoUrl": "https://static.swapcard.com/public/images/7b69152893044de9bd64e3bd51d49861.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTkzMTEzMg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NDE5Mjg=",
        "type": "Speaker",
        "firstName": "Amir",
        "lastName": "Lababedi",
        "jobTitle": "Managing Director, Development, Middle East & North Africa",
        "organization": "Hilton",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/680561716a3e4d46a0f67850724b0c6b.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjkyNA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NDI0NTk=",
        "type": "Speaker",
        "firstName": "Charbel",
        "lastName": "Boutros",
        "jobTitle": "VP Development MEA",
        "organization": "IHG",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/60072b9b11384997844faa8e0428849d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Sponsor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQyOQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NjE4MTc=",
        "type": "Speaker",
        "firstName": "Badr",
        "lastName": "Alherbish",
        "jobTitle": "Chief Strategy Officer",
        "organization": "Tourism Development Fund",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/353e634b19054fcf80a53494476d5475.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjM4ODEwMg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NjIwMDE=",
        "type": "Speaker",
        "firstName": "Sarah",
        "lastName": "Gasim",
        "jobTitle": "Senior Vice President, Head of Hotels KSA",
        "organization": "JLL",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/295c94c5f792461ea1fb5840b840ad14.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTk0NjQzNQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3NjQ3MTI=",
        "type": "Speaker",
        "firstName": "Oli",
        "lastName": "Thomas",
        "jobTitle": "Founder",
        "organization": "Hatchin",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b3cdc73d91e7445891a75b6ffba552f7.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTk0ODQ5Nw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3ODI0NzU=",
        "type": "Speaker",
        "firstName": "Amr",
        "lastName": "El Nady",
        "jobTitle": "Head of Hotels & Hospitality MEA and Managing Director, Global Hotel Desk",
        "organization": "JLL",
        "photoUrl": "https://static.swapcard.com/public/images/982df6695622462cb476e3a7cc2650db.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTk2NTcyNA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk3ODU0NjY=",
        "type": "Speaker",
        "firstName": "Patrick",
        "lastName": "Antaki",
        "jobTitle": "Chief Operating Officer (COO)",
        "organization": "Hospitality Management Holding (HMH)",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4a2dde1c40f944acabf340bdd53b0e73.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQzMQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4MTA3NDg=",
        "type": "Speaker",
        "firstName": "Cladys",
        "lastName": "Magagna",
        "jobTitle": "Corporate Director of Food & Beverage",
        "organization": "Al Khozama Investment Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/7cc5cd45d6194f1fa501e8934b130a43.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTk4MjYyNg==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4MTA3Njg=",
        "type": "Speaker",
        "firstName": "Hossam",
        "lastName": "Al-Basrawi",
        "jobTitle": "General Manager Corporate Banking Group",
        "organization": "Alrajhi Bank",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/658ff82efa1e4d6cb2bdfd0126429425.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Bank/Lender",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTk4MjY0MQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4MTA5Mjg=",
        "type": "Moderator",
        "firstName": "Stefan",
        "lastName": "Breg",
        "jobTitle": "Managing Partner-Consulting",
        "organization": "KEANE: Consult & Create",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/41525c7c9fe74668bbba9fb57926cf94.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTk4Mjc0OQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4MTM1NDE=",
        "type": "Speaker",
        "firstName": "Maya",
        "lastName": "Ziade",
        "jobTitle": "Chief Development Officer Premium, Midscale and Economy Division Middle East, Africa & Turkey",
        "organization": "Accor",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/660d55ffc1b24be5a5746988e679b0cc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDY5Mw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4MTQzMTI=",
        "type": "Speaker",
        "firstName": "Fadi",
        "lastName": "Alaseri",
        "jobTitle": "Senior Director - Education",
        "organization": "Red Sea Global (RSG)",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/baeb7330bf9c4f5886147e60d2f7601a.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTk4NTE0MA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4MzE0Mjk=",
        "type": "Speaker",
        "firstName": "Nawal",
        "lastName": "AlKhalawi",
        "jobTitle": "Founder & CEO",
        "organization": "Asfar Experience",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/000a7f217fcb45009a6c5bc62eeae305.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNTk5NzU4OA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4NTU2Nzc=",
        "type": "Speaker",
        "firstName": "Dr. Hamad",
        "lastName": "Abuhaimed",
        "jobTitle": "Chief Executive Officer",
        "organization": "Shatha Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/a941619d5bf94efc936e637a487f1112.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjAxNjE0NQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4NzQ4Mjc=",
        "type": "Moderator",
        "firstName": "Nichola",
        "lastName": "Beskine-Taylor",
        "jobTitle": "Partner",
        "organization": "TGP International",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/7adbc8bfdcd54036828c175c446b77c6.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjAzMDY2Mw==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4NzYwMDg=",
        "type": "Judge",
        "firstName": "Maya",
        "lastName": "Ayoub",
        "jobTitle": "Founder & CEO",
        "organization": "District Twelve",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/9f57a657fa7b440dbeec75056094dbb4.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Judge",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjAzMTQ3OA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4OTE1MDE=",
        "type": "Speaker",
        "firstName": "Vikram",
        "lastName": "Natarajan",
        "jobTitle": "Chief Executive Officer",
        "organization": "Kayanee",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/852e440e483f4ee18b5921d9b2cb299e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjA0Mjk3NQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4OTE1MDU=",
        "type": "Speaker",
        "firstName": "Dr. Martin",
        "lastName": "Berlin",
        "jobTitle": "Partner & Global Deals Real Estate Leader",
        "organization": "PwC Middle East",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/275c4c5c246c4caba6ee97c01df8cdd3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTkyMjcxNA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4OTE1MjU=",
        "type": "Speaker",
        "firstName": "Ankur",
        "lastName": "Agrawal",
        "jobTitle": "CEO & Founder",
        "organization": "Inhabitr",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b3ff5b51d6b54a2787c0617014e2803f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjA0Mjk5MQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4OTE1NDE=",
        "type": "Speaker",
        "firstName": "Carlos",
        "lastName": "Khneisser",
        "jobTitle": "Vice President Development Middle East & Africa",
        "organization": "Hilton",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/fd2d5fa65f704f1896360c6fd505e0ab.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQyOA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk4OTE1Nzk=",
        "type": "Moderator",
        "firstName": "Catherine",
        "lastName": "Edwards",
        "jobTitle": "Chief Strategy Officer",
        "organization": "QUO",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/106b486cd5244f33ba513c57c90e0178.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTkxOTE2OQ==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5MDM1ODQ=",
        "type": "Speaker",
        "firstName": "Ian",
        "lastName": "Palmer",
        "jobTitle": "Executive Director - Venues",
        "organization": "MDLBEAST",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/cdb133f6d73542af8dc3df5908c5e4f2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjA1MjU5OA==",
                    "createdAt": "2024-04-22 12:32:13"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5MDQ0MDQ=",
        "type": "Moderator",
        "firstName": "James",
        "lastName": "Hacon",
        "jobTitle": "Founding Partner",
        "organization": "Think Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjI5NTU4Mg==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5MDQ4MTY=",
        "type": "Speaker",
        "firstName": "Talar",
        "lastName": "Keshishian",
        "jobTitle": "Senior Manager Leasing – Retail Development",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/9c97616c746f4003b83cbace862bf597.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjA1MzcxOA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5MDU4NDI=",
        "type": "Speaker",
        "firstName": "Martin",
        "lastName": "Boudreau",
        "jobTitle": "President and Executive Producer - Parks & Hospitality",
        "organization": "Cirque du Soleil Entertainment Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2ce509c419cf45c2b951b118d453711e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjA1NDU2NQ==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5MDg4Nzg=",
        "type": "Speaker",
        "firstName": "Jean-Jacques",
        "lastName": "Morin",
        "jobTitle": "Group Deputy CEO and Premium, Midscale & Economy Division CEO",
        "organization": "Accor",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/96add8627cc94ae29086196e24ee65b6.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDY0MA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5MTQ3OTA=",
        "type": "Speaker",
        "firstName": "Madan",
        "lastName": "Manjeshwar",
        "jobTitle": "Director of Finance",
        "organization": "AlMoajil Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/98f78b7a3f0d49a4b53db9adb3f8bd45.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjA2MTQ3OA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5NzgyMzc=",
        "type": "Speaker",
        "firstName": "Sam",
        "lastName": "Bakhshandehpour",
        "jobTitle": "President & Board Member",
        "organization": "José Andrés Group (JAG)",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/46a16339843641dfae39ca89faaf369d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEwMTg0MA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5ODE4ODU=",
        "type": "Moderator",
        "firstName": "Ben",
        "lastName": "Baseley-Walker",
        "jobTitle": "Founder & Managing Partner",
        "organization": "Andart Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/288a7ad5b80448359b1f72694ccbc88d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM5OA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5OTc4NTU=",
        "type": "Speaker",
        "firstName": "Stephen",
        "lastName": "Ansell",
        "jobTitle": "Managing Director – Middle East and Africa",
        "organization": "Hyatt",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/68a36c2c3cde4c0ea405fdf3c809aa46.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjExNzI0OA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMjk5OTc4ODU=",
        "type": "Speaker",
        "firstName": "Lynne",
        "lastName": "Bellinger",
        "jobTitle": "Director of Food & Beverage Design & Development",
        "organization": "Marriott International EAME",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/80e13f081e84417393d70f5707ea943d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNzQ3Ng==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMDA1NTc=",
        "type": "Speaker",
        "firstName": "Emma",
        "lastName": "Banks",
        "jobTitle": "VP, F&B Strategy and Development EMEA",
        "organization": "Hilton",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/6931016ab4e64957a53dff385397a780.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjg2Mw==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMDA3OTY=",
        "type": "Speaker",
        "firstName": "Dominique",
        "lastName": "Backhouse",
        "jobTitle": "Founder & Managing Director - Hong Kong & Singapore",
        "organization": "Companion Communications",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/97c8d1b26223405ebc9c96241bcdf3e7.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjExOTU5Mw==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMDM4OTQ=",
        "type": "Speaker",
        "firstName": "Rohit",
        "lastName": "Sachdev",
        "jobTitle": "Chief Executive Officer",
        "organization": "Soho Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c77a869bdd4a465db0e93c34d8e34b77.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjgxNA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMDM5ODY=",
        "type": "Speaker",
        "firstName": "HE Gloria",
        "lastName": "Guevara Manzo",
        "jobTitle": "Chief Special Advisor",
        "organization": "Minister of Tourism of Saudi Arabia",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/526572d8e1d94f85b637866279c2f58c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEyMjIzNw==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMDQ2MzM=",
        "type": "Moderator",
        "firstName": "Nicolas",
        "lastName": "Mayer",
        "jobTitle": "Industry Leader Hospitality and Tourism EMEA; Managing Partner Global Center of Excellence Tourism & Hospitality",
        "organization": "PwC",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/9260ea72f29c4a1f83d82b4462921838.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEyMjc2NA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMTM0MjE=",
        "type": "Speaker",
        "firstName": "Gautam",
        "lastName": "Sashittal",
        "jobTitle": "Chief Executive Officer",
        "organization": "King Abdullah Financial District Development & Management Company (KAFD DMC)",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b50fd85b20e5475c83c076a6890d01f8.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEzMDE5OA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMTM0NDU=",
        "type": "Speaker",
        "firstName": "Aboudi",
        "lastName": "Asali",
        "jobTitle": "Executive Vice President, Head of Hotels Advisory MENA",
        "organization": "JLL",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/6bec2df7ac174d53baeb9dbf8656e21c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjU3ODU5Nw==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMTM0NjA=",
        "type": "Moderator",
        "firstName": "Jules",
        "lastName": "Ugo",
        "jobTitle": "Chief Executive Officer",
        "organization": "Lotus",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b6731e369c8e42d18c1e81aec244adb2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEzMDIyNw==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMTM0Nzk=",
        "type": "Speaker",
        "firstName": "Abdulrahman",
        "lastName": "Abaalkhail",
        "jobTitle": "Chief Executive Officer",
        "organization": "Dan Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/95be7c05998b4bb1a1f8c6b2adb1f718.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEzMDI0MQ==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMTM1MDE=",
        "type": "Moderator",
        "firstName": "Anton",
        "lastName": "Bawab",
        "jobTitle": "Independent Hospitality Advisor",
        "organization": null,
        "photoUrl": "https://cdn-api.swapcard.com/public/images/815fc65a8e05412a9a86591a64c524fe.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEzMDI1OQ==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMTM1MzQ=",
        "type": "Speaker",
        "firstName": "Alberto",
        "lastName": "Bounous",
        "jobTitle": "Vice President Design & Development",
        "organization": "KAFD DMC",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ede45ae2239c442f85e4e394594738ed.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEzMDI3OQ==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMjA1ODA=",
        "type": "Moderator",
        "firstName": "Linh",
        "lastName": "Vu",
        "jobTitle": "Founder & CEO",
        "organization": "Key Hospitality Consulting",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/04f7de3e5c3b474d9573e40c05ddb716.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEzNTY1NA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMjA1ODg=",
        "type": "Speaker",
        "firstName": "Pascal",
        "lastName": "Donat",
        "jobTitle": "Chairman & Founder, Maison ELLE",
        "organization": "President, de Valotel",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/8192f6a9be2f4362ba9e5760a925238b.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjEzNTY1OQ==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMjY3ODE=",
        "type": "Speaker",
        "firstName": "Dr. Khalid",
        "lastName": "Alshaibani",
        "jobTitle": "Chief Executive Officer",
        "organization": "Health Sector Transformation Program",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d204935d67fc457f99c925f513b166dd.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE0MDgwMA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwMjgzODE=",
        "type": "Speaker",
        "firstName": "Jana",
        "lastName": "Bader",
        "jobTitle": "Advisor",
        "organization": "the bench",
        "photoUrl": "https://static.swapcard.com/public/images/c7a4cf6c87574c7cb8a30a99afcb55e2.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM1Ng==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNDU2ODE=",
        "type": "Speaker",
        "firstName": "Elyza",
        "lastName": "Falzon",
        "jobTitle": "Vice President - Architecture, Design & Construction",
        "organization": "Hilton Worldwide Services Limited",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/9a5c3f84af374083ba66f43de4cddaac.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NTQwMw==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNDU3Mjg=",
        "type": "Speaker",
        "firstName": "Marina",
        "lastName": "Franolic",
        "jobTitle": "Head of Investor Relations",
        "organization": "The Bench",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MTE=",
                "name": "Organisers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE1NTY1Nw==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNDYwMTE=",
        "type": "Speaker",
        "firstName": "Daniel von",
        "lastName": "Barloewen",
        "jobTitle": "Regional Vice President, Accor One Living",
        "organization": "Head of Mixed-Use (EMEA), ACCOR",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/5cf473e2ddec40608d2edc80e017428d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQ1NQ==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNDYxNzk=",
        "type": "Speaker",
        "firstName": "Daria",
        "lastName": "Smith",
        "jobTitle": "Portfolio Director",
        "organization": "The Bench",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Staff",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE1NjA1MA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNDc2MDQ=",
        "type": "Speaker",
        "firstName": "Gaurav",
        "lastName": "Sinha",
        "jobTitle": "CEO",
        "organization": "Insignia Worldwide",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/90fc35e1480c41078f9fcdb37669236e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjkzNA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNDc2NDI=",
        "type": "Moderator",
        "firstName": "Judith",
        "lastName": "Cartwright",
        "jobTitle": "Founder & Managing Director",
        "organization": "Black Coral Consulting",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/efa02cf95da1468d9d912a2d6314cb69.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NTQyNg==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNDgxMTA=",
        "type": "Moderator",
        "firstName": "Reem",
        "lastName": "Garash",
        "jobTitle": "Partner- KSA Consulting & Valuation",
        "organization": "HVS",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/5bde145a692341bb8fa8ad92e96aa07e.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE1NzY2OQ==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNDg5MTk=",
        "type": "Moderator",
        "firstName": "Daniela",
        "lastName": "Wagner",
        "jobTitle": "Global Business Development Director",
        "organization": "Jacobs Media",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/fb8d2368d05d47a8a87f2a636653a2c0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE1ODI5Ng==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNTg1ODk=",
        "type": "Speaker",
        "firstName": "Mateo",
        "lastName": "Ramos",
        "jobTitle": "Chief Executive Officer",
        "organization": "Foodvest Holding WLL",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/9d3b7e962fdc4b8c8bf4f31f77278902.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE2NDYxMg==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNTg5MzU=",
        "type": "Speaker",
        "firstName": "Moustafa",
        "lastName": "Said",
        "jobTitle": "Partner",
        "organization": "Wisefields Law",
        "photoUrl": "https://static.swapcard.com/public/images/18bdf4b7d36e46a4909308223311f493.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Lawyer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Sponsor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE2NDg4Ng==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNTkwODk=",
        "type": "Speaker",
        "firstName": "Kurt",
        "lastName": "Zdesar",
        "jobTitle": "Chef, Founder & Owner",
        "organization": "Chotto Matte",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d3070b8eba24461eb956ce983f237021.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE2NTAzNQ==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNjI1Njg=",
        "type": "Speaker",
        "firstName": "Hicham",
        "lastName": "Hassouni",
        "jobTitle": "Chief Strategy & Business Development Officer",
        "organization": "Boutique Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d1f3ad2cb0074368988c7bc07cb88071.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTQxNA==",
                    "createdAt": "2024-04-22 12:32:14"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNjMyNjI=",
        "type": "Speaker",
        "firstName": "Michelle",
        "lastName": "Turney",
        "jobTitle": "Head of Partnerships",
        "organization": "The Bench",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MTE=",
                "name": "Organisers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Staff",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2MDYyNQ==",
                    "createdAt": "2024-04-22 12:32:17"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNjMyOTM=",
        "type": "Moderator",
        "firstName": "Son-Trang",
        "lastName": "Nguyen",
        "jobTitle": "Production Manager",
        "organization": "The Bench",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MTE=",
                "name": "Organisers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE2ODUxMQ==",
                    "createdAt": "2024-04-22 12:32:08"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNjM0NjU=",
        "type": "Moderator",
        "firstName": "Georgie",
        "lastName": "Woollams",
        "jobTitle": "Founder & Managing Director",
        "organization": "Katch International",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/f919d7764b18472e83cfc5f1f6a661ef.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Other",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8xNjkwNjk0MA==",
                    "createdAt": "2024-04-22 12:32:08"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwNzY1MzE=",
        "type": "Judge",
        "firstName": "Nouf",
        "lastName": "Alharthi",
        "jobTitle": "Manager of Business Development",
        "organization": "TDF Grow",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/6bd7e238d45146a8b504bd8f5ef02bea.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Judge",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE3ODcyNg==",
                    "createdAt": "2024-04-22 12:32:08"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwOTgxNzc=",
        "type": "Moderator",
        "firstName": "Greg",
        "lastName": "Wright",
        "jobTitle": "Co-Founder & Managing Partner",
        "organization": "Food People",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/332bde98a705475ab2931065e2b606e3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE5NzAzNQ==",
                    "createdAt": "2024-04-22 12:32:09"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwOTkyMzU=",
        "type": "Speaker",
        "firstName": "Andrew",
        "lastName": "Williamson",
        "jobTitle": "Senior Director - Retail Development",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/223f34fd755d4799ad09fad0c1d92d35.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE5Nzg5OA==",
                    "createdAt": "2024-04-22 12:32:09"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAwOTkyNDc=",
        "type": null,
        "firstName": "Panchali",
        "lastName": "Mahendra",
        "jobTitle": "CEO",
        "organization": "Atelier House Hospitality FZ-LLC",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjE5NzkwNw==",
                    "createdAt": "2024-04-27 20:16:07"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAxNzY3Mjk=",
        "type": "Speaker",
        "firstName": "Mawadah",
        "lastName": "Bajrai",
        "jobTitle": "Food Innovator and Researcher",
        "organization": "",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/627fda7deeb84336a92975e6c40c28fc.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI2MDUzOA==",
                    "createdAt": "2024-04-25 07:29:18"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAxNzcyMTE=",
        "type": "Speaker",
        "firstName": "Eng. Abdulaziz",
        "lastName": "M. Al-Shanqiti",
        "jobTitle": "Director General, Investment Development Division",
        "organization": "Royal Commission for Jubail and Yanbu (RCJY).",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/df0dbe950d0e42cdb9471d071bc9e51f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI2MDg4OQ==",
                    "createdAt": "2024-04-22 12:32:09"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAxNzcyMzA=",
        "type": "Speaker",
        "firstName": "Sherif M.",
        "lastName": "Elsherif",
        "jobTitle": "Managing Director - MENA",
        "organization": "Olayan Food Services Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/f4e14ea5815c43eabea0e39bea4a04d1.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI2MDkwNg==",
                    "createdAt": "2024-04-22 12:32:09"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAxNzc0MjQ=",
        "type": "Speaker",
        "firstName": "Michael",
        "lastName": "Thorley",
        "jobTitle": "Project Director, Expenditure and Projects Efficiency Authority (Expro)",
        "organization": "DAR Engineering",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e9bed244849a48be9728bd60edad1cf0.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI2MTA0OQ==",
                    "createdAt": "2024-04-22 12:32:09"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAxODM4ODE=",
        "type": "Speaker",
        "firstName": "Faisal",
        "lastName": "Younes",
        "jobTitle": "CEO F&B",
        "organization": "Cenomi Retail",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4be07ad6431a4dc4a79d2ae4cf031cab.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI2NjA5Nw==",
                    "createdAt": "2024-04-22 12:32:09"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyMDM5Mjg=",
        "type": null,
        "firstName": "Faisal",
        "lastName": "Al Bassam",
        "jobTitle": "DMC General Manager",
        "organization": "Baheej",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/5ca1753737c44b2ca30d48ce719ff535.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjQ3MjUyMQ==",
                    "createdAt": "2024-04-22 12:32:08"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyMDQ5Mjc=",
        "type": "Moderator",
        "firstName": "Reina",
        "lastName": "Takla",
        "jobTitle": "Business Editor",
        "organization": "Arab News",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1255f4454d664f8d92346e01094267ab.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI4MjQwMw==",
                    "createdAt": "2024-04-22 12:32:10"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyMDUwNDU=",
        "type": "Speaker",
        "firstName": "Maria",
        "lastName": "Pichon",
        "jobTitle": "Director Brand Development",
        "organization": "NEOM Hotel Division",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/dd66d705f0ce465296e009143ca4325d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTc4NTQ0Ng==",
                    "createdAt": "2024-04-22 12:32:10"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyMDUwNjM=",
        "type": "Speaker",
        "firstName": "Agnès",
        "lastName": "Roquefort",
        "jobTitle": "Chief Development Officer, Luxury & Lifestyle",
        "organization": "Accor",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b11bfb415f7942958d0cd947ffd68b3c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NjI0MA==",
                    "createdAt": "2024-04-22 12:32:10"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyMjYxNTQ=",
        "type": null,
        "firstName": "Nadeem",
        "lastName": "Zaman",
        "jobTitle": "Chief Strategy & EPMO Officer",
        "organization": "Rua Al Madinah Holding Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/29306b1391e84768a7cb5e2c0933c6c1.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI5OTE4OA==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyMjYxODY=",
        "type": "Speaker",
        "firstName": "Mubarak",
        "lastName": "Alsufayan",
        "jobTitle": "Hospitality BD Manager Investment and Asset",
        "organization": "Rua Al Madinah Holding Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/50e8d629d2ee4771aeba09b6938ec8da.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjI5OTIwOQ==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyMzI3MzE=",
        "type": "Speaker",
        "firstName": "Rashid",
        "lastName": "Aboobacker",
        "jobTitle": "Asset Manager",
        "organization": "Rua Al Madinah Holding Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/657107b0213243948feee33d7bdfc6ec.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjAyNTM1Nw==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyNDQ0OTc=",
        "type": "Speaker",
        "firstName": "Abdulhalim",
        "lastName": "Awlia",
        "jobTitle": "Regional Operations Specialist",
        "organization": "NEOM Hotel Division",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/8f0a9299e62c4e2986aba3e11a60ddf2.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMxMzY4NA==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyNDQ5NTg=",
        "type": "Speaker",
        "firstName": "Ulpa",
        "lastName": "Chauhan",
        "jobTitle": "Chief Solutions Officer",
        "organization": "Beyond Bamboo",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ddf727d59fc44d3d85fa5a868e371b72.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMxNDA2MQ==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyNDQ5ODI=",
        "type": "Speaker",
        "firstName": "Peggy",
        "lastName": "Li",
        "jobTitle": "Managing Partner",
        "organization": "SPS Affinity",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/efe71ac9b3d7472f8a47c69a09b3b3a1.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY1NTM3OQ==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyNDQ5OTE=",
        "type": "Speaker",
        "firstName": "Simone",
        "lastName": "Mundy Clowry",
        "jobTitle": "Chief Operating Officer",
        "organization": "Beyond Bamboo",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/4b87482b6ba34cdd855ee4941808b88f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Consultant/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMxNDA4Mg==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyNjQ3NTE=",
        "type": "Speaker",
        "firstName": "Samer",
        "lastName": "Sabra",
        "jobTitle": "Chief Asset Management Officer",
        "organization": "Jabal Omar Development Company",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d70a454a25eb49d39b9086c7bb899092.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Other",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMzMDAwOA==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyNjc5Nzc=",
        "type": "Speaker",
        "firstName": "Angela",
        "lastName": "Lester",
        "jobTitle": "Executive Vice President Business Development EMEA",
        "organization": "sbe",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/fed23640ad04465f901ceb297c132571.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMzMjc4Mw==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyNjgzNjI=",
        "type": "Speaker",
        "firstName": "Lyndsey",
        "lastName": "Scott",
        "jobTitle": "Director",
        "organization": "MJS Investment",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/77a90ce238794634997f871479c6c8c8.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMzMzA2Mw==",
                    "createdAt": "2024-04-22 12:32:11"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyNzE5Mzg=",
        "type": "Speaker",
        "firstName": "Malinalli",
        "lastName": "Ramirez Martinez",
        "jobTitle": "Ph.D. candidate",
        "organization": "King Abdullah University of Science and Technology",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c2b05c7122df40f9b950da9b7cae0228.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Student",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMzNTU1MQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyNzE5NDY=",
        "type": "Speaker",
        "firstName": "Banan",
        "lastName": "Alhazmi",
        "jobTitle": "Researcher (Ph.D. Candidate)",
        "organization": "KAUST",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/9a2d716043e0477ea64c365ad7c88eeb.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjMzNTU1OQ==",
                    "createdAt": "2024-04-22 12:32:12"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyOTg0NTU=",
        "type": "Speaker",
        "firstName": "Jihad",
        "lastName": "Dirani",
        "jobTitle": "VP New Development Leasing",
        "organization": "Cenomi Centers",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bb81d210bd524d4c80a36f2522c4de28.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM1MzQ4Ng==",
                    "createdAt": "2024-04-23 09:07:47"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyOTg1MTQ=",
        "type": "Speaker",
        "firstName": "Mohamed",
        "lastName": "Siam",
        "jobTitle": "Chief Operating Officer",
        "organization": "Trofi",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/7d65f4d204da4832878f187e3bd20607.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM1MzUzMA==",
                    "createdAt": "2024-04-23 09:07:47"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAyOTg1OTY=",
        "type": "Speaker",
        "firstName": "Ana",
        "lastName": "Martins",
        "jobTitle": "Director, Interior Design",
        "organization": "ARC International Design Consultants",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/dd57025983104c75946e38dee4bbbd46.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM1MzU5NA==",
                    "createdAt": "2024-04-23 09:07:47"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzMDIwNTU=",
        "type": "Speaker",
        "firstName": "Fredrik",
        "lastName": "Jonsson",
        "jobTitle": "Board Member, Hospitality Asset Management Association",
        "organization": "Chief Asset Management Officer, ASFAR",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/7a67798b991d4ed08f014ff6ead87064.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM1NjUxMA==",
                    "createdAt": "2024-04-23 09:07:48"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzMDIwNzg=",
        "type": null,
        "firstName": "Wael",
        "lastName": "Qenawy",
        "jobTitle": "CRM & CX Director",
        "organization": "TROFI",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM1NjUzMg==",
                    "createdAt": "2024-04-23 09:07:48"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzMzUwNjg=",
        "type": "Speaker",
        "firstName": "Holkan",
        "lastName": "Vasquez",
        "jobTitle": "PhD Student",
        "organization": "King Abdullah University of Science and Technology, Saudi Arabia",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/1fc4d5fe0392489988538e7cd51fa741.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM4NDM4Mw==",
                    "createdAt": "2024-04-25 07:29:18"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNTY1MDE=",
        "type": null,
        "firstName": "Louis",
        "lastName": "Thompson",
        "jobTitle": "CEO & Founder",
        "organization": "Nomadic Escape",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/8258815cc5304a04a04d76903e376971.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDc=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM5OTg4Nw==",
                    "createdAt": "2024-04-25 07:29:18"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNTY1MTA=",
        "type": "Speaker",
        "firstName": "Girish",
        "lastName": "Prabhu",
        "jobTitle": "CEO & Co-Founder",
        "organization": "Instio Experiences",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d25f6481d60a41a9828c95a6bfd8cf7f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDc=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Supplier",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM5OTg5NA==",
                    "createdAt": "2024-04-25 07:29:18"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNTY1NzA=",
        "type": "Speaker",
        "firstName": "Mohamed",
        "lastName": "Zhran",
        "jobTitle": "CEO & Founder",
        "organization": "Tenance",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c2a8cb08a8814029b1b5a58cd12a18f7.png",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDc=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM5OTk0Mw==",
                    "createdAt": "2024-04-25 07:29:18"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNTY2MjY=",
        "type": "Speaker",
        "firstName": "Sam",
        "lastName": "Payrovi",
        "jobTitle": "CEO & Co-Founder",
        "organization": "ARKHAUS",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/370ee834c0de40b0a662d70545962e0b.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDc=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjM5OTk5OA==",
                    "createdAt": "2024-04-25 07:29:18"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNTY2NTk=",
        "type": "Speaker",
        "firstName": "Sharan",
        "lastName": "Bhinder",
        "jobTitle": "COO & Co-Founder",
        "organization": "SPARKLEHAZE",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/c6f33f3d26a74d3aab3ee4f766ce18c3.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDc=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwMDAyOA==",
                    "createdAt": "2024-04-25 07:29:18"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNTY3MDA=",
        "type": "Speaker",
        "firstName": "Lorelei",
        "lastName": "Regragui",
        "jobTitle": "Founder & CEO",
        "organization": "StayK",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/76a30635a1ac4c9f9ea238fae8fb80dd.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDc=",
                "name": "Attendees"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Technology/Innovation",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwMDA2Mw==",
                    "createdAt": "2024-04-25 07:29:18"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNjUwMzI=",
        "type": null,
        "firstName": "Yann",
        "lastName": "Callaert",
        "jobTitle": "CEO",
        "organization": "Daniel Ost Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/df060694a5bb4b8fa4b40f7907847040.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Supplier",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwNTMwNg==",
                    "createdAt": "2024-04-25 07:29:19"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNjUwNDg=",
        "type": null,
        "firstName": "Fadwa",
        "lastName": "Al Enezi",
        "jobTitle": "Sales Manager",
        "organization": "Shaza Hotels",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwNTMyMQ==",
                    "createdAt": "2024-04-25 07:29:19"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNjUwNzU=",
        "type": null,
        "firstName": "Helen",
        "lastName": "O'Connor",
        "jobTitle": "Creative Director",
        "organization": "Daniel Ost Group",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwNTM0Ng==",
                    "createdAt": "2024-04-25 07:29:19"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNjUwNzY=",
        "type": null,
        "firstName": "Natsuko",
        "lastName": "Koriyama",
        "jobTitle": "Floral Designer",
        "organization": "Daniel Ost Group",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwNTM0Nw==",
                    "createdAt": "2024-04-25 07:29:19"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNjUwNzg=",
        "type": null,
        "firstName": "Victoria",
        "lastName": "Clemson",
        "jobTitle": "Operations Director",
        "organization": "Daniel Ost Group",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwNTM0OQ==",
                    "createdAt": "2024-04-25 07:29:19"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNjUwODI=",
        "type": null,
        "firstName": "Walaa",
        "lastName": "Al Oubari",
        "jobTitle": "Business & Event Director",
        "organization": "Daniel Ost Group",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwNTM1NA==",
                    "createdAt": "2024-04-25 07:29:19"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNjUwODM=",
        "type": null,
        "firstName": "Sophie",
        "lastName": "Samba",
        "jobTitle": "Business Development",
        "organization": "Daniel Ost Group",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Architect/Designer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwNTM1Mw==",
                    "createdAt": "2024-04-25 07:29:19"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNjU2OTY=",
        "type": null,
        "firstName": "Muteb",
        "lastName": "Bin Jumaiah",
        "jobTitle": "Section Head, Organization Development",
        "organization": "Taiba Investments",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/f6fc97b946ab4007ac44c3a895c2f747.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwNTkxMw==",
                    "createdAt": "2024-04-25 16:37:32"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNjY3Mjc=",
        "type": "Speaker",
        "firstName": "Jasniya",
        "lastName": "Badsha",
        "jobTitle": "Co-Founder",
        "organization": "RiyadhConnect",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/49c12d5057ae42eebb002bedfd2ecb0c.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQwNjc3Mw==",
                    "createdAt": "2024-04-25 16:37:32"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzNzY0MzI=",
        "type": "Speaker",
        "firstName": "Ashraf",
        "lastName": "Qasem",
        "jobTitle": "Chief Hospitality Officer",
        "organization": "Al Othaim Investments",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b573a490063b4424afa5fea09eb971bb.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            },
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDk=",
                "name": "Sponsors"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQxNTExOQ==",
                    "createdAt": "2024-04-25 16:37:32"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzODEzMDg=",
        "type": "Speaker",
        "firstName": "Mohammed",
        "lastName": "Attia",
        "jobTitle": "Chief Executive Officer",
        "organization": "Al Othaim Investments",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/78ee76730e1b4efdbf2660838b13834f.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQxNzU3MQ==",
                    "createdAt": "2024-04-25 16:37:32"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzODI3Mjk=",
        "type": "Speaker",
        "firstName": "Ahmad",
        "lastName": "Almutawa",
        "jobTitle": "Investment Management Executive Director",
        "organization": "ASFAR",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b95be56a957247a5a0ef5782ed81378d.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjUwOTkxNA==",
                    "createdAt": "2024-04-25 16:37:32"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzODI4Mjg=",
        "type": "Speaker",
        "firstName": "Rabih",
        "lastName": "Feghali",
        "jobTitle": "Board Member",
        "organization": "Hospitality Asset Management Association",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bde0f2da88104f85b7b4d69ce0181547.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Investor/Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMjQ4OTU3Ng==",
                    "createdAt": "2024-04-25 16:37:34"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzAzOTg4MzI=",
        "type": "Speaker",
        "firstName": "Alessandra",
        "lastName": "Priante",
        "jobTitle": "President",
        "organization": "Italian National Tourist Board",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/b0805fdb5e41489b92f167c336021bba.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQzMTAxNA==",
                    "createdAt": "2024-04-26 10:35:02"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA0NTgwNDY=",
        "type": "Speaker",
        "firstName": "Paul",
        "lastName": "Stevens",
        "jobTitle": "Chief Operating Officer, Middle East, Africa and Türkiye, Premium, Midscale and Economy Division",
        "organization": "Accor",
        "photoUrl": "https://static.swapcard.com/public/images/aeaf719f57974ea8986281b5449483bf.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Hotel/Resort Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer/Builder",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zMTY2NDM5Mg==",
                    "createdAt": "2024-04-27 20:16:07"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA0NTgwNDc=",
        "type": null,
        "firstName": "Ahmed",
        "lastName": "Almazrou",
        "jobTitle": "Manager Protocol",
        "organization": "Tourism Development Fund",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "translations": [
                        {
                            "value": "Tourism / Government Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQ4NzAyMw==",
                    "createdAt": "2024-04-27 20:16:07"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA0NjE3MzQ=",
        "type": null,
        "firstName": "Waleed Saud",
        "lastName": "Abu Haimed",
        "jobTitle": "CEO",
        "organization": "Tatweer",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQ5MDM1NA==",
                    "createdAt": "2024-04-28 18:55:54"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA0NjE4Mjc=",
        "type": "Moderator",
        "firstName": "Yasmine",
        "lastName": "Vanda Trofast",
        "jobTitle": "Founder & Owner",
        "organization": "YVT Consultancy",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/bc950859492046ad952ecf3bfa045a74.jpeg",
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQ5MDQzOA==",
                    "createdAt": "2024-04-28 18:55:54"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA0NjM3MTA=",
        "type": null,
        "firstName": "Fritz",
        "lastName": "Dickamp",
        "jobTitle": "Managing Director",
        "organization": "Studio 49",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Media",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {},
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjQ5MjE4MA==",
                    "createdAt": "2024-04-28 18:55:54"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA1MjEyOTk=",
        "type": null,
        "firstName": "Reham",
        "lastName": "Shalaby",
        "jobTitle": "HR Maneger",
        "organization": "MFC",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjU0MTk2OA==",
                    "createdAt": "2024-04-30 06:54:54"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA1MjEzNDk=",
        "type": null,
        "firstName": "Alanoud",
        "lastName": "Bin Baz",
        "jobTitle": "Manager of Marketing",
        "organization": "MFC",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjU0MjAxNg==",
                    "createdAt": "2024-04-30 06:54:54"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA1MjEzNTA=",
        "type": null,
        "firstName": "Fatina",
        "lastName": "Shaker",
        "jobTitle": "director",
        "organization": "MFC",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjU0MjAxNw==",
                    "createdAt": "2024-04-30 06:54:54"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA1MjEzNTE=",
        "type": null,
        "firstName": "Bassam",
        "lastName": "Nassar",
        "jobTitle": "director",
        "organization": "MFC",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "F&B Investor / Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzU2MzAxNQ==",
                        "translations": [
                            {
                                "name": "BUSINESS TYPE",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {}
            ],
            "badges": [
                {
                    "__typename": "BadgeBarcode",
                    "barcode": "Q29tbXVuaXR5UHJvZmlsZV8zNjU0MjAxOA==",
                    "createdAt": "2024-04-30 06:54:54"
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzA1MjM2NTk=",
        "type": "Speaker",
        "firstName": "Rafael",
        "lastName": "Espeja",
        "jobTitle": "Asset Manager",
        "organization": "Rua Al Madinah Holding Company",
        "photoUrl": null,
        "groups": [
            {
                "id": "RXZlbnRHcm91cF8zOTI4MDg=",
                "name": "Speakers"
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Speaker",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzMxMzIwOQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ],
            "badges": []
        }
    }
]